import { IS_TEST } from './environment';

/** Keys that start with this prefix will not be removed from local storage when the user logs out. */
export const PERSISTENT_PREFIX = 'PERSISTENT_';

/**
 * Stores a value in local storage.
 */
export function storeLocally(
  key: string,
  value: unknown,
  replacerFunction?: (this: any, key: string, value: any) => any,
): void {
  try {
    localStorage.setItem(key, JSON.stringify(value, replacerFunction));
  } catch (err) {
    console.warn('Error setting local storage', err);
  }
}

export function getLocally<T = unknown>(key: string): T | null {
  try {
    const stored = localStorage.getItem(key);
    if (stored) {
      return JSON.parse(stored);
    }
    return null;
  } catch (err) {
    if (!IS_TEST) {
      console.warn(`Error retrieving item "${key}" from local storage`, err);
    }
    return null;
  }
}

export function removeLocally(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.warn('Error removing local storage', err);
  }
}

export function clear(): void {
  try {
    localStorage.clear();
  } catch (error) {
    console.warn('Could not clear local storage', error);
  }
}

/**
 * Clears all keys that don't start with PERSISTENT_PREFIX.
 * @param optionalKeys optional keys that should be persisted, see impersonationUtils > impersonateUser()
 */
export function clearNonPersistent(optionalKeys?: string[]): void {
  try {
    for (const key of Object.keys(localStorage)) {
      if (!key.startsWith(PERSISTENT_PREFIX) && !optionalKeys?.includes(key)) {
        removeLocally(key);
      }
    }
  } catch {
    clear();
  }
}

export default {
  storeLocally,
  getLocally,
  removeLocally,
  clear,
  clearNonPersistent,
};
